export default __webpack_public_path__ + "static/media/logo_carfix_partner.418906c6.png";